import { kFramelessPanelWidth } from "../constants";
import { AddFramelessButton } from "./AddFramelessButton";

export function AddFramelessCopyButton(parent, aCmd, label) {
  var button = AddFramelessButton(parent, label, "copy-" + aCmd, kFramelessPanelWidth - 20, 1);
  return button;
}
